module.exports = __webpack_public_path__ + "img/intro2_ko.29242538.jpg";